import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter as Router, useLocation, Route, Switch } from "react-router-dom";
import { useNavigatorOnLine } from "./utils/Hooks/useAPIFetch";
import Homepage from "./Components/Homepage/Homepage";
import ProtectedRouteWrapper from "./Components/Dashboard/ProtectedRouteWrapper";
import Dashboard from "./Components/Dashboard/Dashboard";
import { UserProvider } from "./utils/Contexts/Context";
import Auth from "./Components/Auth/Auth";
function App() {
    useNavigatorOnLine();
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <UserProvider>
                <Switch>
                    <ProtectedRouteWrapper path="/dashboard">
                        <Dashboard />
                    </ProtectedRouteWrapper>
                    <Route path="/auth">
                        <Auth />
                    </Route>
                    <Route path="">
                        <Homepage />
                    </Route>
                </Switch>
            </UserProvider>
            <ScrollTop />
            <Toaster toastOptions={{ style: { fontSize: 14 } }} />
        </Router>
    );
}

export default App;

// Used to Scroll to top of page on page route
function ScrollTop() {
    const path = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [path.pathname]);
    return null;
}
